import { BrandLockup } from '@onepos/ui';

/** Qulf ekranlari pastidagi kichik imzo: ekran restoranniki, ONE POS — faqat imzo (Q-032) */
export function LockSign() {
  return (
    <div className="ks-sign">
      <BrandLockup height={20} tone="side" title="ONE POS" />
    </div>
  );
}
